<template>
    <div class="trafficking-screening">
        <div class="print-button-container">
            <b-button
                type="button"
                variant="outline-primary"
                size="md"
                @click="printForm"
            >
            <span class="button-text">
                Print Form
            </span>
            </b-button>
        </div>
        <br>
        <h3>
           Louisiana Child and Youth Sex Trafficking Identification Tool
        </h3>
        <br>
        <p
            class="trafficking-screening__description"
            v-for="(item, id) in detailFields"
            :key="id"
        >
            <span class="trafficking-screening__description trafficking-screening__description--bold">
                {{ item.title }}:
            </span>
            {{ item.value }}
        </p>
        <div class="trafficking-screening__table">
            <b-row class="trafficking-screening__row">
                <b-col cols="12">
                    <p class="trafficking-screening__header">
                        <b>Section 1: Commercial Sexual Activity</b>
                    </p>
                    <span class="trafficking-screening__header trafficking-screening__description--bold trafficking-screening__description--italic">
                        Has the child/youth ever engaged in sex or sex acts for anything of value?
                    </span>
                    <span class="trafficking-screening__header trafficking-screening__description--italic">Items of value may include money, food, a place to stay, drugs, gifts, transportation, or something else. Select all that apply.</span>
                </b-col>
                <b-col cols="12">
                    <b-form-group disabled>
                        <span class="trafficking-screening__description--bold">
                            Exploitation Indicators
                        </span>
                        <p>The child/youth has:</p>
                        <div class="trafficking-screening__checkbox-group">
                            <b-form-checkbox
                                :class="{'trafficking-screening__checkbox': true, 'font-weight-bold': value.boldDesc}"
                                v-for="[key, value] of Object.entries(section1Fields['Exploitation'])"
                                :key="key"
                                v-model="traffickingScreening[key]"
                            >
                                {{ value.desc }}
                            </b-form-checkbox>
                        </div>
                    </b-form-group>
                    <b-form-group disabled>
                        <span class="trafficking-screening__description--bold">
                           Vulnerability Indicators
                        </span>
                        <p>The child/youth has:</p>
                        <div class="trafficking-screening__checkbox-group">
                            <b-form-checkbox
                                :class="{'trafficking-screening__checkbox': true, 'font-weight-bold': value.boldDesc}"
                                v-for="[key, value] of Object.entries(section1Fields['Vulnerability']['0'])"
                                :key="key"
                                v-model="traffickingScreening[key]"
                            >
                                {{ value.desc }}
                            </b-form-checkbox>
                        </div>
                        <br>
                        <p>The child/youth is:</p>
                        <div class="trafficking-screening__checkbox-group">
                            <div 
                                v-for="[key, value] of Object.entries(section1Fields['Vulnerability']['1'])"
                                :key="key"
                            >
                                <div v-if="!value.type">
                                    <b-form-checkbox
                                        :class="{'trafficking-screening__checkbox': true, 'font-weight-bold': value.boldDesc}"
                                        :key="key"
                                        v-model="traffickingScreening[key]"
                                    >
                                        {{ value.desc }}
                                    </b-form-checkbox>
                                </div>
                                <div v-if="value.type === 'other'">
                                    <b-form-checkbox
                                        class="trafficking-screening__checkbox"
                                        v-model="traffickingScreening[key]"
                                    >
                                        {{ value.desc }}
                                        <!-- <b-form-input
                                            class="trafficking-screening__form-input"
                                            v-model="traffickingScreening[value.textVar]"
                                        /> -->
                                        <!-- <b-form-textarea
                                            class="trafficking-screening__otherTextArea"
                                            v-model="traffickingScreening[value.textVar]"
                                        /> -->
                                        <p class="trafficking-screening__otherTextArea">{{ traffickingScreening[value.textVar]}}</p>
                                    </b-form-checkbox>
                                </div>
                            </div>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <p class="trafficking-screening__header">
                        <b>Section 2: Perpetrator Actions</b>
                    </p>
                    <span class="trafficking-screening__header trafficking-screening__description--bold trafficking-screening__description--italic">
                        Has someone facilitated, enticed, or benefitted from the sexual activity of the child/youth?
                    </span>
                    <span class="trafficking-screening__header trafficking-screening__description--italic">This may be a parent, family member, friend, employer, or romantic partner. Select all that apply.</span>
                </b-col>
                <b-col cols="12">
                    <b-form-group disabled>
                        <span class="trafficking-screening__description--bold">
                            Exploitation Indicators
                        </span>
                        <p>Someone has:</p>
                        <div class="trafficking-screening__checkbox-group">
                            <b-form-checkbox
                                :class="{'trafficking-screening__checkbox': true, 'font-weight-bold': value.boldDesc}"
                                v-for="[key, value] of Object.entries(section2Fields['Exploitation'])"
                                :key="key"
                                v-model="traffickingScreening[key]"
                            >
                                {{ value.desc }}
                            </b-form-checkbox>
                        </div>
                        <br>
                        <span class="trafficking-screening__description--bold">
                            Vulnerability Indicators
                        </span>
                        <p>Someone is:</p>
                        <div class="trafficking-screening__checkbox-group">
                            <div 
                                v-for="[key, value] of Object.entries(section2Fields['Vulnerability'])"
                                :key="key"
                            >
                                <div v-if="!value.type">
                                    <b-form-checkbox
                                        :class="{'trafficking-screening__checkbox': true, 'font-weight-bold': value.boldDesc}"
                                        :key="key"
                                        v-model="traffickingScreening[key]"
                                    >
                                        {{ value.desc }}
                                    </b-form-checkbox>
                                </div>
                                <div v-if="value.type === 'other'">
                                    <b-form-checkbox
                                        class="trafficking-screening__checkbox"
                                        v-model="traffickingScreening[key]"
                                    >
                                        {{ value.desc }}
                                        <!-- <b-form-input
                                            class="trafficking-screening__form-input"
                                            v-model="traffickingScreening[value.textVar]"
                                        /> -->
                                         <!-- <b-form-textarea
                                            class="trafficking-screening__otherTextArea"
                                            v-model="traffickingScreening[value.textVar]"
                                        /> -->
                                        <p class="trafficking-screening__otherTextArea">{{ traffickingScreening[value.textVar]}}</p>
                                    </b-form-checkbox>
                                </div>
                            </div>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <p class="trafficking-screening__header">
                        <b>Section 3: Current Abuse</b>
                    </p>
                    <span class="trafficking-screening__header trafficking-screening__description--bold trafficking-screening__description--italic">
                        Is the child/youth currently experiencing abuse, neglect, or other forms of harm?
                    </span>
                     <span class="trafficking-screening__header trafficking-screening__description--italic">Please select which types of abuse, neglect, or other forms of harm (from the last 90 days) you have knowledge of or concerns about for this child/youth. Select all that apply</span>
                </b-col>
                <b-col cols="12">
                    <b-form-group disabled>
                         <p class="trafficking-screening__description--bold">
                            Vulnerability Indicators
                        </p>
                        <!-- <br> -->
                        <div class="trafficking-screening__checkbox-group">
                            <div 
                                v-for="[key, value] of Object.entries(section3Fields)"
                                :key="key"
                            >
                                <div v-if="!value.type">
                                    <b-form-checkbox
                                        :class="{'trafficking-screening__checkbox': true, 'font-weight-bold': value.boldDesc}"
                                        :key="key"
                                        v-model="traffickingScreening[key]"
                                    >
                                        {{ value.desc }}
                                    </b-form-checkbox>
                                </div>
                                <div v-if="value.type === 'other'">
                                    <b-form-checkbox
                                        class="trafficking-screening__checkbox"
                                        v-model="traffickingScreening[key]"
                                    >
                                        {{ value.desc }}
                                         <!-- <b-form-textarea
                                            class="trafficking-screening__form-input"
                                            v-model="traffickingScreening[value.textVar]"
                                        /> -->
                                        <p class="trafficking-screening__otherTextArea">{{ traffickingScreening[value.textVar]}}</p>
                                    </b-form-checkbox>
                                </div>
                            </div>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>
        </div>
        <div class="trafficking-screening__container">
            <p class="trafficking-screening__header"><b>Final Screening Results and Actions:</b></p>

            <div class="mb-0" v-if="traffickingScreening.conclusion === TRAFFICKING_SCREENING_CONCLUSION_ENUM.NOT_ENOUGH_INFO">
                <p :class="tsConclusionClasses">{{ TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[this.traffickingScreening.conclusion] }} [Monitor]</p>
                <br>
                <p>There is not enough information to determine whether the child/youth is experiencing sex trafficking. <b>Continue to monitor the child/youth</b>; upon learning more information, re-screen the child/youth.</p>
            </div>
            <div class="mb-0" v-else-if="traffickingScreening.conclusion === TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL1">
                <p :class="tsConclusionClasses">{{ TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[this.traffickingScreening.conclusion] }} [Re-Screen]</p>
                <br>
                <p>There is concern for possible sex trafficking. If you are a mandatory reporter and have suspicion or knowledge of child abuse (ex: physical or sexual abuse) or neglect (ex: malnourishment), you are required by law to make a mandatory report to DCFS or law enforcement. <b>Screen again in 90 days or upon learning new information</b>. Consider referring the child/youth to additional services as needed and appropriate. Consider utilizing the group sharing feature on the top right hand corner of this page to share this record with your region's care coordination team.</p>
            </div>
            <div class="mb-0" v-else-if="traffickingScreening.conclusion === TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL2">
                <p :class="tsConclusionClasses">{{ TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[this.traffickingScreening.conclusion] }} [Report]</p>
                <br>
                <p>The child/youth is considered “indicated” for sex trafficking. As a result, this case warrants review by a Louisiana Human Trafficking Regional Care Coordination Team. <b>Immediately call the DCFS Child Abuse/Neglect Hotline at 855-452-5437 (option 4) to report human trafficking involving a child under the age of 18 years old</b>. If the youth is aged 18 years or older, provide them with the National Human Trafficking Hotline at 888-373-7888 and offer to make a referral to a local service provider with expertise in human trafficking. If the suspected victim is an adult with a disability, report also to Adult Protective Services at 800-898-4910. <b>Utilize the group sharing feature on the top right hand corner of this page to share this record with your region's care coordination team</b>.</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import { TRAFFICKING_SCREENING_CONCLUSION_ENUM, TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP } from '@/helpers/enums'

export default {
    name: 'PrintTraffickingScreening',

    data () {
        return {
            friendlyScreeningId: this.$route.params.id,
            TRAFFICKING_SCREENING_CONCLUSION_ENUM,
            TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP
        }
    },

    computed: {
        ...mapGetters({
            traffickingScreening: 'getTraffickingScreening',
            traffickingScreeningFields: 'getTraffickingScreeningFields'
        }),

        section1Fields () {
            return this.traffickingScreeningFields['ONE']
        },

        section2Fields () {
            return this.traffickingScreeningFields['TWO']
        },

        section3Fields () {
            return this.traffickingScreeningFields['THREE']
        },

        tsConclusionClasses () {
            return [
                'mb-0',
                'trafficking-screening__description',
                'trafficking-screening__description--bold',
                {
                    'text-warning': this.traffickingScreening.conclusion === TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL1,
                    'text-danger': this.traffickingScreening.conclusion === TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL2
                }
            ]
        },

        personAge () {
            if (
                !this.traffickingScreening ||
                !this.traffickingScreening.person ||
                !this.traffickingScreening.person.b_birthdate
            ) {
                return ''
            }

            const birthDate = this.traffickingScreening.person.b_birthdate
            const birthDateUnix = moment(birthDate).unix()

            if (Number.isNaN(birthDateUnix)) {
                return this.traffickingScreening.person.b_approximate_age || ''
            }
            return moment(Date.now()).diff(birthDate, 'year')
        },

        detailFields () {
            if (!this.traffickingScreening) {
                return []
            }

            const {
                id,
                organizationCreator,
                location,
                program,
                createdBy,
                person
            } = this.traffickingScreening

            const programName = program ? (
                program.title === 'Other' ? program.title_otherText : program.title
            ) : ''

            return [
                {
                    title: 'Agency',
                    value: organizationCreator ? organizationCreator.title : ''
                },
                {
                    title: 'Location',
                    value: location ? location.title : ''
                },
                {
                    title: 'Program',
                    value: programName
                },
                {
                    title: 'Email',
                    value: createdBy ? createdBy.emailAddress : ''
                },
                {
                    title: 'Person Record',
                    value: person ? person.id : ''
                },
                {
                    title: 'Screening Number',
                    value: id
                },
                {
                    title: 'Youth\'s Age',
                    value: this.personAge
                },
                {
                    title: 'Youth\'s Gender Identity',
                    value: person.b_gender === 'Other'
                        ? person.b_gender_otherText
                        : person.b_gender
                },
                {
                    title: 'Youth\'s Race',
                    value: person.b_race === 'Other'
                        ? person.b_race_otherText
                        : person.b_race
                },
                {
                    title: 'Youth\'s Ethnicity',
                    value: person.b_ethnicity || ''
                }
            ]
        }
    },

    created () {
        this.$store.dispatch('getTraffickingScreening', {
            id: this.friendlyScreeningId
        })
    },

    methods: {
        printForm () {
            window.print()
        }
    }
}
</script>

<style lang="scss" scoped>
.trafficking-screening {
    &__header {
        display: block;
    }

    &__description {
        &--bold {
            font-weight: 500;
        }

        &--italic {
            font-style: italic;
        }
    }

    &__checkbox {
        display: block;
    }

    &__checkbox-group {
        padding: 0 15px;
    }
    &__otherTextArea {
        width: 100%;
        max-width: 700px;
        background-color: #c2cfd6;
        border: 1px solid #c2cfd6;
        padding: 0.375rem 0.75rem;
    }

    &__table {
        margin: 15px;
    }

    &__row {
        border: 1px solid #000000;
        border-bottom: none;

        .col-12 {
            padding: 15px;
            border-bottom: 1px solid #000000;
        }
    }

    &__container {
        margin-bottom: 40px;
        padding: 15px;
        border: 1px solid #000000;
    }
}

@media print {
    .trafficking-screening__checkbox {
        -webkit-print-color-adjust: exact !important;   /* Chrome, Safari 6 – 15.3, Edge */
        print-color-adjust: exact !important;           /* Firefox 97+, Safari 15.4+ */
    }

    .print-button-container {
		display: none;
    }
}
</style>

<style>
@media print {
    .breadcrumb, .app-footer {
        display: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/t1/Admin/PrintTraffickingScreening.vue